import React from "react"
import { withRouter } from "react-router-dom"
import { withMyDataContext } from "../../context/DataProvider"

class ScrollToTop extends React.Component {
    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        /* setTimeout(() => {
          document.getElementById("sideBar").scrollIntoView()
        }, 300) */
        //window.scrollBy(0,200)
        var isHashtag = this.props.location.pathname.split("/")
        if(isHashtag && isHashtag[1] !== "hashtag"){
          this.props.myDataProvider.setNewHashtag("")
        }
       // console.log(this.props.location.pathname.Substring(0,"/"))
        document.getElementById("sideBar").scrollTo(0,0)
      }

    }
  
    render() {
      return this.props.children
    }
  }
  
  export default withMyDataContext(withRouter(ScrollToTop))